import React from "react";
import { Link } from "react-router-dom";
import { organisation, trainings } from "../../data/clearith";

const TrainingDetail: React.FC = () => {
  const training = trainings[0];
  const programmeSubject = encodeURIComponent(
    `Demande de programme — ${training.title}`
  );

  return (
    <>
      <section className="cl-training-hero">
        <div className="container">
          <div className="row gy-5 align-items-end">
            <div className="col-lg-8">
              <span className="cl-eyebrow">Formation certifiante · RS6905</span>
              <h1>{training.title}</h1>
              <p>{training.objective}</p>
              <div className="cl-training-hero__actions">
                <Link className="thm-btn agency-btn" to="/contact">
                  <span className="text">Demander des informations</span>
                </Link>
                <a
                  className="cl-outline-btn"
                  href={`mailto:${organisation.email}?subject=${programmeSubject}`}
                >
                  Recevoir le programme
                </a>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="cl-training-price">
                <span>Tarif par participant</span>
                <strong>2 300 € TTC</strong>
                <small>Frais de certification inclus</small>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cl-training-meta">
        <div className="container">
          <div className="cl-training-meta__grid">
            {[
              ["Durée", training.duration],
              ["Organisation", training.organisation],
              ["Rythme indicatif", training.rhythm],
              ["Modalité", "À distance"],
              ["Prérequis", "Niveau A2 CECRL"],
              ["Certificateur", training.certifier],
            ].map(([label, value]) => (
              <div key={label}>
                <span>{label}</span>
                <strong>{value}</strong>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cl-page-section">
        <div className="container">
          <div className="row gy-5">
            <div className="col-lg-8">
              <div className="cl-content-block">
                <span className="cl-kicker">Objectif et certification</span>
                <h2 className="cl-section-title">
                  Communiquer en anglais avec efficacité dans un contexte
                  professionnel.
                </h2>
                <p className="cl-lead">{training.objective}</p>
                <div className="cl-skill-grid">
                  {training.skills.map((skill, index) => (
                    <div key={skill}>
                      <span>0{index + 1}</span>
                      <strong>{skill}</strong>
                    </div>
                  ))}
                </div>
              </div>

              <div className="cl-content-block">
                <span className="cl-kicker">Programme synthétique</span>
                <h2 className="cl-section-title">Quatre modules de 7 heures.</h2>
                <div className="cl-module-list">
                  {training.modules.map((module, index) => (
                    <article key={module.title}>
                      <span>{String(index + 1).padStart(2, "0")}</span>
                      <div>
                        <h3>{module.title}</h3>
                        <p>{module.description}</p>
                      </div>
                      <strong>7 h</strong>
                    </article>
                  ))}
                </div>
              </div>

              <div className="cl-content-block">
                <span className="cl-kicker">Modalités pédagogiques</span>
                <h2 className="cl-section-title">
                  Une formation à distance, interactive et appliquée.
                </h2>
                <div className="cl-tag-list">
                  {training.pedagogy.map((item) => (
                    <span key={item}>{item}</span>
                  ))}
                </div>
              </div>

              <div className="cl-content-block">
                <span className="cl-kicker">Évaluation</span>
                <h2 className="cl-section-title">
                  Suivre les acquis et préparer la certification.
                </h2>
                <ul className="cl-check-list">
                  {training.evaluation.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
                <p className="cl-body-copy">
                  La certification évalue la compréhension orale, la
                  compréhension écrite, l’expression orale et l’expression
                  écrite dans un contexte professionnel.
                </p>
              </div>
            </div>

            <div className="col-lg-4">
              <aside className="cl-sticky-summary">
                <span className="cl-kicker">À qui s’adresse la formation ?</span>
                <p>{training.audience}</p>
                <hr />
                <span className="cl-kicker">Financement</span>
                <p>
                  CPF sous réserve de l’éligibilité de l’offre publiée, OPCO,
                  employeur, financement personnel ou France Travail selon
                  acceptation du dossier.
                </p>
                <Link className="cl-text-link" to="/financement">
                  Étudier les possibilités <span aria-hidden="true">↗</span>
                </Link>
                <hr />
                <span className="cl-kicker">Accessibilité</span>
                <p>
                  Des aménagements peuvent être étudiés à partir d’un échange
                  préalable sur les besoins.
                </p>
                <Link className="cl-text-link" to="/accessibilite">
                  Notre démarche <span aria-hidden="true">↗</span>
                </Link>
                <Link className="thm-btn agency-btn cl-summary-btn" to="/contact">
                  <span className="text">Être rappelé</span>
                </Link>
              </aside>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TrainingDetail;
